:host {
  --text-color: var(--pos-primary-color);
  font-family: var(--font-sans);
}

button {
  line-height: var(--scale-0);
  font-family: inherit;
  margin: 0;
  padding: 0;
  display: flex;
  background: none;
  border: none;
  cursor: pointer;
}

button,
a {
  color: var(--text-color);
  font-weight: var(--weight-light);
  line-height: var(--scale-0);
  font-size: var(--scale-0);
  font-family: inherit;
}

.container {
  display: flex;
  gap: var(--size-1);
  flex-direction: row;
  align-items: center;
  line-height: var(--scale-0);
}
